import React, { useState, useEffect, useRef } from "react";
import {
  TextField,
  Button,
  IconButton,
  Typography,
  Box,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  Stack,
  useThemeProps,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { keyframes } from "@mui/system";
import Logo from "../../assets/images/common/chat-logo.png";
import Link from "@mui/material/Link";
import Autocomplete from "@mui/material/Autocomplete";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Grid from "@mui/material/Grid2";
import { useTheme } from "@mui/material/styles";
import { Filleddiscopybtn, Logout } from "../../icons/icons";
import send from "../../assets/images/common/send-messege-img.svg";
import CircularProgress from "@mui/material/CircularProgress";
import { Snackbar, Alert } from "@mui/material";
import Zoom from "@mui/material/Zoom";

import {
  Newchat,
  Dropdown,
  Gemini,
  Chatlike,
  Chatdislike,
  Chatrefresh,
  Chatcopy,
  Sendmessege,
  Modalclose,
  Hamburguricon,
  Filledlikebtn,
  Filleddislikebtn,
} from "../../icons/icons";

import { useDispatch, useSelector } from "react-redux";
import {
  ChatHistory,
  Clearchat,
  ConnetionHistory,
  ModelSelection,
  chatlike,
  resetChat,
} from "../../redux/chatslice";
import Geminichat from "../../assets/images/common/gemini-chat-logo.png";
import Asklmschat from "../../assets/images/common/asklms-chat-logo.png";
import Mistralchat from "../../assets/images/common/mistral-chat-logo.png";
import Gemmachat from "../../assets/images/common/gemma-chat-logo.png";
import Addllmchat from "../../assets/images/common/add-llm-chat-logo.png";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import Chatgpt from "../../assets/images/common/chatgpt-logo.png";
import Geminilogo from "../../assets/images/common/gemini-logo.png";
import Gemma from "../../assets/images/common/gemma-logo.png";
import Mistral from "../../assets/images/common/mistral-logo.png";
import Websearch from "../../assets/images/common/web-search-logo.png";
import Tick from "../../assets/images/common/tick-icon.png";
import { SendChatQuery } from "../../redux/chatslice";
import { decryptUserId } from "../../utilis/encrypto";
// import base_url from "../../commanimage";
import {base_url,base_urls} from "../../constant";
import {
  Lastchathistory,
  ModelReselect,
  Balancereminder,
} from "../../redux/chatslice";
import { Logoutapi } from "../../redux/authSlice";
import Modelicon from "../../assets/images/common/model-icon.svg";
import { useNavigate } from "react-router-dom";

function Chat({ connection, allResponses, setAllResponses, reset, onClear, historyData, chatid, active }) {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const { model } = useSelector((state) => state.chat);
  const [isFilled, setIsFilled] = useState(false);
  const [currentChatId, setCurrentChatId] = useState(null);
  const [lastHistory, setLastHistory] = useState([]);
  const [feedbackMessage, setFeedbackMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const { queryResponse, history, queryerror } = useSelector(
    (state) => state.chat
  );
  const [textGeneration, setTextGeneration] = useState();
  const [feedbackResponse, setFeedbackResponse] = useState(null);
  const [submittedPrompt, setSubmittedPrompt] = useState("");
  const [lastTimestamp, setLastTimestamp] = useState(null);
  const [timestamp, setTimestamp] = useState();
  const [llmId, setLlmId] = useState();
  const [movedToUnselected, setMovedToUnselected] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const dispatch = useDispatch();
  const [prompt, setPrompt] = useState("");
  const [selectedChat, setSelectedChat] = useState(null);
  const [chattingId, setChattingId] = useState(null);
  const [imageGeneration, setImageGeneration] = useState([]);
  const [feedbackStatus, setFeedbackStatus] = useState("");
  const [displayModels, setDisplayModels] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const chatContainerRef = useRef(null);
  const [previousPayload, setPreviousPayload] = useState(null);
  const [regenerating, setRegenerating] = useState(false);
  const [showLowBalanceModal, setShowLowBalanceModal] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  // const base_urls = "https://pstgs.appsndevs.com/chatrap/"
  // const base_urls = "https://api.imagnce.com/chatrap/"
  
  
  const openLowBalanceModal = () => {
    setShowLowBalanceModal(true);
  };
  const closeLowBalanceModal = () => {
    setShowLowBalanceModal(false);
  };
  const openLow = () => {
    active();
    setShowLowBalanceModal(true);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(ModelSelection());
  }, [dispatch]);

  useEffect(() => {
    if (model.text_model?.length > 0) {
      setTextGeneration(model.text_model);
    }
  }, [model.text_model]);

  useEffect(() => {
    // console.log("Current chatId:", chatid);

    if (Array.isArray(chatid)) {
      // console.log("Processing chatid as an array");

      const matchedModels = textGeneration?.filter((item) => {
        // console.log(`Checking item.id: ${item.id} with chatid: ${chatid}`);
        return chatid.includes(String(item.id));
      });

      // console.log("Matched models:", matchedModels);

      setDisplayModels(matchedModels);

    } else {
      // console.log("chatid is not an array or is undefined.");
      setDisplayModels([]);
    }
  }, [textGeneration, chatid]);

  // console.log(displayModels, "displayModels");

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, [allResponses]);

  useEffect(() => {
    if (model.image_model) {
      setImageGeneration(model.image_model);
    }
  }, [model.image_model]);

  useEffect(() => {
    if (!reset) {
      setFeedbackStatus();
      dispatch(ConnetionHistory(connection))
        .then((connectionResponse) => {
          if (connectionResponse.error) {
            // console.error("ConnectionHistory failed:", connectionResponse.error);
            return;
          }

          dispatch(Lastchathistory(historyData)).then((response) => {
            if (response.payload && response.payload.data) {
              const fetchedChatHistory = response.payload.data;
              setAllResponses(fetchedChatHistory);
            }
          });
        })
        .catch((error) => {
          console.error("Error in ConnectionHistory:", error);
        });
    }
  }, [dispatch, connection, historyData]);

  const handleActive = (id) => {
    const elementBeforeToggle = textGeneration.find((el) => el.id === id);

    const updatedState = textGeneration.map((element) =>
      element.id === id
        ? { ...element, isSelected: !element.isSelected }
        : element
    );

    setTextGeneration(updatedState);

    if (elementBeforeToggle.isSelected) {
      const movedItem = { ...elementBeforeToggle, isSelected: false };
      setMovedToUnselected((prev) => [...prev, movedItem]);
    } else {
      setMovedToUnselected((prev) => prev.filter((item) => item.id !== id));
    }

    const currentlySelectedItems = updatedState.filter(
      (item) => item.isSelected
    );
    setSelectedItems(currentlySelectedItems);
  };

  const handleSave = () => {
    const encryptedUserId = localStorage.getItem("userId");
    const userId = decryptUserId(encryptedUserId);

    if (!userId) {
      console.error("Failed to decrypt user ID.");
      return;
    }

    const selectedIds = selectedItems.map((item) => item.id.toString());
    const unselectedIds = movedToUnselected.map((item) => item.id.toString());

    const payload = {
      user_id: userId,
      selected: selectedIds,
      unselected: unselectedIds,
    };
    setDisplayModels([]);
    onClear()
    dispatch(ModelReselect(payload))
      // .then((response) => {
      //   console.log("lais",response)
      //   if (response.payload && response.payload.data) {
      //     const updatedModels = response.payload.data.text_model.map((model) => ({
      //       ...model,
      //       isSelected: model.isSeletced, // Assuming typo, update to `isSelected`
      //     }));
      //     console.log("lais",updatedModels)

      //     // Only show models where isSelected is true
      //     const filteredModels = updatedModels.filter((model) => model.isSelected);

      //     setTextGeneration(filteredModels);
      //   } else {
      //     console.error("No data found in ModelSelection response.");
      //   }
      // })
      .catch((error) => {
        console.error("Error during API calls:", error);
      });
  };




  useEffect(() => {
    const currentTimestamp = Date.now();
    setTimestamp(currentTimestamp);
  }, [setTimestamp]);

  const handleClickChatmodel = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseChatmodel = () => {
    setAnchorEl(null);
  };

  const handleClickChat = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseChat = () => {
    setAnchorEl(null);
  };

  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleModelClick = (modelId) => {
    // console.log("Clicked chat with model ID:", modelId);
    setChattingId(modelId);
    const selectedModel = textGeneration.find((item) => item.id === modelId);
    if (!selectedModel) {
      console.error("Model not found with ID:", modelId);
      return;
    }
    setSelectedChat(selectedModel);

    const storedTimestamp = localStorage.getItem("lastTimestamp");
    const timestamp = storedTimestamp || selectedModel.timestamp;

    setLastTimestamp(timestamp);
    localStorage.setItem("lastTimestamp", timestamp);
    // console.log("Timestamp used:", timestamp);

    const encryptedUserId = localStorage.getItem("userId");
    const userId = decryptUserId(encryptedUserId);

    if (!userId) {
      console.error("Failed to decrypt user ID.");
      return;
    }

    if (selectedModel.text_model?.length > 0) {
      setTextGeneration(selectedModel.text_model);
    }

    const lastChatPayload = {
      user_id: userId,
      timestamps: timestamp,
      llm_id: modelId.toString(),
    };

    dispatch(Lastchathistory(lastChatPayload)).then((response) => {
      if (response.payload && response.payload.data) {
        const fetchedChatHistory = response.payload.data;
        setAllResponses(fetchedChatHistory);
      }
    });
  };

  if (allResponses?.length > 0) {
    const lastResponse = allResponses[allResponses.length - 1];
    // console.log("Last Response:", lastResponse);
  } else {
    console.log("No responses available.");
  }
  const handleChatlike = (isLiked) => {
    setFeedbackResponse(isLiked);
    setFeedbackMessage();
    const selectedTextModels = textGeneration
      .filter((item) => item.isSelected)
      .map((item) => item.id.toString());
    const selectedImageModels = imageGeneration
      .filter((item) => item.isSelected)
      .map((item) => item.id.toString());

    const llmType =
      selectedTextModels.length > 0
        ? selectedTextModels[0]
        : selectedImageModels.length > 0
          ? selectedImageModels[0]
          : "default_llm_type";

    const encryptedUserId = localStorage.getItem("userId");

    const userId = decryptUserId(encryptedUserId);
    if (!userId) {
      console.error("Failed to decrypt user ID.");
      return;
    }

    const lastMessage =
      allResponses?.length > 0 ? allResponses[allResponses.length - 1] : null;


    const lastMessageId =
      lastMessage && (lastMessage.messageId || lastMessage.message_id)
        ? lastMessage.messageId || lastMessage.message_id
        : null;


    const ChatPayload = {
      user_id: userId,
      llm_id: llmType,
      feedback_response: isLiked,
      message_id: lastMessageId,
    };


    dispatch(chatlike(ChatPayload)).then((response) => {
      if (response.payload && response.payload.status_code === 200) {
        const feedbackResult = isLiked ? "liked" : "unliked";
        setFeedbackStatus(feedbackResult);
        setSnackbarOpen(true);
        setFeedbackMessage(
          response.payload.message || "Feedback recorded successfully."
        );
      } else {
        console.error("Error in chatlike response:", response);
      }
    });
  };


  useEffect(() => {
    const lastTimestamp = localStorage.getItem("lastTimestamp");
    const lastChat = history.find((chat) => chat.timestamp === lastTimestamp);
    if (lastChat) {
      setSelectedChat(lastChat);
    }
  }, [history]);

  useEffect(() => {
    dispatch(ChatHistory());
  }, [dispatch]);
  const handleChange = (e) => setPrompt(e.target.value);

  useEffect(() => {
    const storedTimestamp = localStorage.getItem("lastTimestamp");

    if (storedTimestamp) {
      setTimestamp(Number(storedTimestamp));
    } else {
      const newTimestamp = Date.now();
      setTimestamp(newTimestamp); // Set as number
      localStorage.setItem("lastTimestamp", newTimestamp.toString()); // Store as string
    }
  }, []);

  const handleSubmit = () => {
    if (!Array.isArray(textGeneration) || !Array.isArray(imageGeneration)) {
      console.error("One of the model arrays is not an array:", {
        textGeneration,
        imageGeneration,
      });
      return;
    }

    let storedTimestamp = localStorage.getItem("lastTimestamp");

    if (!storedTimestamp) {
      storedTimestamp = Date.now().toString(); // Store as string
      localStorage.setItem("lastTimestamp", storedTimestamp);
    }

    const timestampValue = Number(storedTimestamp);

    const selectedTextModels = textGeneration
      .filter((item) => item.isSelected)
      .map((item) => item.id.toString());

    const selectedImageModels = imageGeneration
      .filter((item) => item.isSelected)
      .map((item) => item.id.toString());

    if (selectedTextModels.length === 0 && selectedImageModels.length === 0) {
      console.error("No models selected. Please select at least one LLM.");
      return;
    }

    const textImageSelection = selectedImageModels.length > 0;
    const llmType =
      selectedTextModels.length > 0
        ? selectedTextModels
        : selectedImageModels.length > 0
          ? selectedImageModels
          : ["default_llm_type"];

    const encryptedUserId = localStorage.getItem("userId");
    const userId = decryptUserId(encryptedUserId);

    if (!userId) {
      console.error("Failed to decrypt user ID.");
      return;
    }

    setSubmittedPrompt(prompt);
    const llmId = llmType[0];
    setLlmId(llmId);

    const payload = {
      llm_type: llmType,
      query: prompt,
      user_id: userId,
      regenerate: false,
      Text_image_selection: textImageSelection,
      isMine: true,
      timestamps: timestampValue, // Use the timestamp from localStorage
    };

    setPreviousPayload(payload);
    setAllResponses((prevResponses) => [...prevResponses, payload]);

    setLoading(true);
    setHasSubmitted(true);

    dispatch(SendChatQuery(payload))
    .then(() => {

      return dispatch(ChatHistory());

    })

    .catch((error) => {

      console.error("Error during API calls:", error);

      

    })

    .finally(() => {

      setLoading(false); 

    });


    setPrompt("");
  };

  useEffect(() => {
    if (hasSubmitted && !loading) {
      if (queryerror === "LessAmountError") {
        console.error("Less Amount Error detected in queryerror:", queryerror);
        openLowBalanceModal(); // Open modal only for LessAmountError
      } else if (queryerror) {
        console.error("Other error detected in queryerror:", queryerror);
        // Optionally handle other errors (e.g., show a toast)
       
      }
      setLoading(false); // Ensure loading is set to false
      setHasSubmitted(false); // Reset submission state
    }
  }, [queryerror, hasSubmitted, loading]);
  

  const handleRegenerate = () => {
    setLoading(true);

    const encryptedUserId = localStorage.getItem("userId");
    const userId = decryptUserId(encryptedUserId);

    if (!userId) {
      console.error("Failed to decrypt user ID.");
      setLoading(false);
      return;
    }

    const selectedTextModels = textGeneration
      .filter((item) => item.isSelected)
      .map((item) => item.id.toString());

    const selectedImageModels = imageGeneration
      .filter((item) => item.isSelected)
      .map((item) => item.id.toString());

    if (selectedTextModels.length === 0 && selectedImageModels.length === 0) {
      console.error("No models selected. Please select at least one LLM.");
      setLoading(false);
      return;
    }

    const textImageSelection = selectedImageModels.length > 0;
    const llmType =
      chatid ||
      (selectedTextModels.length > 0
        ? selectedTextModels
        : selectedImageModels);


    const timestamp = localStorage.getItem("lastTimestamp");

    if (!timestamp) {
      console.error("No timestamp available in localStorage.");
      setLoading(false);
      return;
    }


    const lastMessage = allResponses
      .filter((message) => message.isMine)
      .slice(-1)[0];

    if (!lastMessage || (!lastMessage.query && !lastMessage.message)) {
      console.error("No valid messages found for regeneration.");
      setLoading(false);
      return;
    }

    const messageText = lastMessage.query || lastMessage.message;


    const regeneratedPayload = {
      regenerate: true,
      user_id: userId,
      timestamps: timestamp,
      llm_type: llmType,
      query: messageText,
      Text_image_selection: textImageSelection,
    };


    dispatch(SendChatQuery(regeneratedPayload)).finally(() => {
      setLoading(false);
    });
  };


  // const handleRegenerate = () => {
  //   setRegenerating(true);
  //   if (!previousPayload) {
  //     console.error("No previous payload available for regeneration.");
  //     return;
  //   }

  //   // Use the previous payload and set regenerate to true
  //   const regeneratedPayload = {
  //     ...previousPayload,
  //     regenerate: true,
  //   };

  //   setLoading(true);
  //   dispatch(SendChatQuery(regeneratedPayload))
  //     .then(() => {
  //       // After successful API call, fetch the updated chat history
  //       return dispatch(ChatHistory());
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  // };

  useEffect(() => {
    const encryptedUserId = localStorage.getItem("userId");
    const userId = decryptUserId(encryptedUserId);

    if (!userId) {
      console.error("Failed to decrypt user ID.");
      return;
    }

    // if (model.text_model?.length > 0) {
    //   setTextGeneration(model.text_model);
    // }

    if (!Array.isArray(textGeneration)) {
      // console.error("textGeneration is not an array:", textGeneration);
      return;
    }

    const selectedModels = textGeneration
      .filter((item) => item.isSelected)
      .map((item) => item.id.toString());

    const llmType =
      selectedModels.length > 0 ? selectedModels : ["default_llm_type"];
    const llmId = llmType[0];

    const storedTimestamp = localStorage.getItem("lastTimestamp");
    // console.log(storedTimestamp, "storedTimestamp", llmId);

    if (storedTimestamp && llmId) {
      const payload = {
        user_id: userId,
        timestamps: storedTimestamp,
        llm_id: llmId,
      };
      dispatch(Lastchathistory(payload)).then((response) => {
        if (response.payload && response.payload.data) {
          const fetchedChatHistory = response.payload.data;
          setAllResponses(fetchedChatHistory);
        }
      });
    }
  }, [model, textGeneration, dispatch]);


  useEffect(() => {
    if (displayModels && displayModels.length > 0) {
      setChattingId(displayModels[0].id);
      // console.log(displayModels[0].id, "eererere");
    } else if (textGeneration && textGeneration.length > 0) {
      const selectedItem = textGeneration.find((item) => item.isSelected);

      if (selectedItem) {
        setChattingId(selectedItem.id);
      }
    }
    if (imageGeneration) {
      // console.log("Inside imageGeneration condition:", imageGeneration);
      const selected = imageGeneration.find((item) => item.isSelected);
      if (selected) {
        setChattingId(selected.id);
        // console.log(selected.id, "selected from imageGeneration");
      } else {
        console.log("No item in imageGeneration is selected.");
      }
    }
  }, [displayModels, textGeneration, imageGeneration]);



  const handleNavigate = (path) => {
    navigate(path);
    handleCloseChat();
  };
  useEffect(() => {
    if (reset) {
      // console.log("Resetting allResponses");
      setAllResponses([]);
      localStorage.removeItem("lastTimestamp");
      setSelectedChat(null);
      setPrompt("");
      dispatch(Clearchat());
      setSubmittedPrompt("");
      setPreviousPayload("");

      // console.log("New timestamp generated:", newTimestamp);

    }
  }, [reset, dispatch]);

  // console.log(history, "history");

  useEffect(() => {
    if (model.text_model?.length > 0) {
      setTextGeneration(model.text_model);
    }
  }, [model]);

  const [openD, setOpenD] = React.useState(false);

  const handleClickOpenD = () => {
    setOpenD(true);
  };

  const handleCloseD = () => {
    setOpenD(false);
  };

  const [openB, setOpenB] = React.useState(false);

  const handleClickOpenB = () => {
    setOpenB(true);
  };

  const handleCloseB = () => {
    setOpenB(false);
  };

  useEffect(() => {
    dispatch(ChatHistory());
  }, [dispatch]);
  // console.log(allResponses, "sponses");

  // useEffect(() => {
  //   if (queryResponse && queryResponse.status === "success") {
  //     const responseMessage = regenerating 
  //       ? queryResponse.data.query 
  //       : queryResponse.data.message;

  //     const responseImageUrl = queryResponse.data.image_url || [];
  //     const messageId = queryResponse.data.message_id;

  //     // Use callback version of setAllResponses to ensure the most recent state is used
  //     setAllResponses((prevResponses) => {
  //       // Check if the message with the given ID already exists
  //       const messageIndex = prevResponses.findIndex(
  //         (msg) => msg.messageId === messageId
  //       );

  //       if (messageIndex !== -1) {
  //         // If the message exists, update the existing one with the regenerated response
  //         const updatedMessage = {
  //           ...prevResponses[messageIndex],
  //           query: regenerating ? responseMessage : prevResponses[messageIndex].query,
  //           message: regenerating ? responseMessage : prevResponses[messageIndex].message,
  //           image_url: responseImageUrl,
  //         };

  //         // Replace the existing message with the updated one
  //         return prevResponses.map((msg, index) =>
  //           index === messageIndex ? updatedMessage : msg
  //         );
  //       } else {
  //         // If the message doesn't exist, add a new one
  //         return [
  //           ...prevResponses,
  //           {
  //             messageId: messageId,
  //             query: regenerating ? responseMessage : null,
  //             message: !regenerating ? responseMessage : null,
  //             isMine: false,
  //             image_url: responseImageUrl,
  //           },
  //         ];
  //       }
  //     });

  //     setFeedbackStatus(null);
  //     setFeedbackResponse(null);
  //   }
  // }, [queryResponse, regenerating]);

  useEffect(() => {
    if (reset) {
      return;
    }

    if (queryResponse && queryResponse.status === "success") {
      const responseMessage = queryResponse.data.message||"";
      const responseImageUrl = queryResponse.data.image_url||"";
      const messageId = queryResponse.data.message_id;
console.log(responseImageUrl,"url")
      // Replace any `\n` with <br /> to create new lines
      const formattedMessage = responseMessage.split("\n").map((line, lineIndex) => (
        <span key={`line-${lineIndex}`}>
          {line.split(/(\*\*.*?\*\*|https?:\/\/[^\s]+)/).map((part, partIndex) => {
            if (/\*\*(.*?)\*\*/.test(part)) {
              // Bold text
              return (
                <b key={`bold-${lineIndex}-${partIndex}`} style={{ color: "black" }}>
                  {part.replace(/\*\*(.*?)\*\*/, "$1")}
                </b>
              );
            } else if (/https?:\/\/[^\s]+/.test(part)) {
              // Link
              return (
                <a
                  key={`link-${lineIndex}-${partIndex}`}
                  href={part}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "blue", textDecoration: "underline" }}
                >
                  {part}
                </a>
              );
            }
            // Plain text
            return part;
          })}
          {lineIndex !== responseMessage.split("\n").length - 1 && <br />}
        </span>
      ));

      setAllResponses((prevResponses) => {
        // Clone previous responses to modify
        const updatedResponses = [...prevResponses];

        // Check the last message in the array
        const lastMessage = updatedResponses[updatedResponses.length - 1];
        if (lastMessage && lastMessage.query == null) {
          
          updatedResponses[updatedResponses.length - 1] = {
            messageId: messageId,
            message: formattedMessage,
            isMine: false,
            image_url: responseImageUrl,
          };
        } else {
          
          const existingIndex = updatedResponses.findIndex(
            (msg) => msg.message_id === `${messageId}_a` || msg.messageId === messageId
          );

          const updatedMessage = {
            messageId: messageId,
            message: formattedMessage,
            isMine: false,
            image_url: responseImageUrl,
          };

          if (existingIndex !== -1) {
           
            updatedResponses[existingIndex] = updatedMessage;
          } else {

            updatedResponses.push(updatedMessage);
          }
        }

        return updatedResponses;
      });

      setFeedbackStatus(null);
      setFeedbackResponse(null);
    }
  }, [queryResponse, regenerating]);

// useEffect(() => {
//   if (reset) {
//     return;
//   }

//   if (queryResponse && queryResponse.status === "success") {
//     const responseMessage = queryResponse.data.message || "";
//     const responseImageUrl = queryResponse.data.image_url || "";
//     const messageId = queryResponse.data.message_id;

//     console.log(responseImageUrl, "url");

//     // Replace any `\n` with <br /> to create new lines
//     const formattedMessage = responseMessage.split("\n").map((line, lineIndex) => (
//       <span key={`line-${lineIndex}`}>
//         {line.split(/(\*\*.*?\*\*|https?:\/\/[^\s]+)/).map((part, partIndex) => {
//           if (/\*\*(.*?)\*\*/.test(part)) {
//             // Bold text
//             return (
//               <b key={`bold-${lineIndex}-${partIndex}`} style={{ color: "black" }}>
//                 {part.replace(/\*\*(.*?)\*\*/, "$1")}
//               </b>
//             );
//           } else if (/https?:\/\/[^\s]+/.test(part)) {
//             // Link
//             return (
//               <a
//                 key={`link-${lineIndex}-${partIndex}`}
//                 href={part}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 style={{ color: "blue", textDecoration: "underline" }}
//               >
//                 {part}
//               </a>
//             );
//           }
//           // Plain text
//           return part;
//         })}
//         {lineIndex !== responseMessage.split("\n").length - 1 && <br />}
//       </span>
//     ));

//     setAllResponses((prevResponses) => {
//       const updatedResponses = [...prevResponses];

//       // Check if the response contains an image URL
//       if (responseImageUrl) {
//         updatedResponses.push({
//           messageId: messageId,
//           isMine: false,
//           image_url: responseImageUrl,
//         });
//       } else {
//         // Handle text-based responses
//         const lastMessage = updatedResponses[updatedResponses.length - 1];
//         if (lastMessage && lastMessage.query == null) {
//           updatedResponses[updatedResponses.length - 1] = {
//             messageId: messageId,
//             message: formattedMessage,
//             isMine: false,
//           };
//         } else {
//           const existingIndex = updatedResponses.findIndex(
//             (msg) => msg.message_id === `${messageId}_a` || msg.messageId === messageId
//           );

//           const updatedMessage = {
//             messageId: messageId,
//             message: formattedMessage,
//             isMine: false,
//           };

//           if (existingIndex !== -1) {
//             updatedResponses[existingIndex] = updatedMessage;
//           } else {
//             updatedResponses.push(updatedMessage);
//           }
//         }
//       }

//       return updatedResponses;
//     });

//     setFeedbackStatus(null);
//     setFeedbackResponse(null);
//   }
// }, [queryResponse, regenerating]);


  // Logging changes in allResponses



  // Logging changes in allResponses
  useEffect(() => {
    // console.log("Updated allResponses:", allResponses);
  }, [allResponses]);



  // useEffect(() => {
  //   if (queryResponse && queryResponse.status === "success") {
  //     const responseMessage = queryResponse.data.message;
  //     const responseImageUrl = queryResponse.data.image_url || [];
  //     const messageId = queryResponse.data.message_id;

  //     setAllResponses((prevResponses) => {
  //       const messageIndex = prevResponses.findIndex(
  //         (msg) => msg.messageId === messageId
  //       );

  //       if (messageIndex !== -1) {
  //         const updatedMessage = {
  //           ...prevResponses[messageIndex],
  //           query: responseMessage,
  //           image_url: responseImageUrl, 
  //         };


  //         return prevResponses.map((msg, index) =>
  //         index === messageIndex ? updatedMessage : msg
  //       );
  //       } else {

  //         return [
  //           ...prevResponses,
  //           {
  //             messageId: messageId,
  //             query: responseMessage,
  //             isMine: false,
  //             image_url: responseImageUrl,
  //           },
  //         ];
  //       }
  //     });
  //     console.log(allResponses,"eeork")
  //     setFeedbackStatus(null);

  //     setFeedbackResponse(null);
  //   }
  // }, [queryResponse, regenerating]);
  const copyLastResponse = () => {
    if (allResponses?.length > 0) {
      const activeChat = allResponses[allResponses.length - 1];

      // Check if activeChat contains a message structure like the one in the example
      let responseText = activeChat.message || activeChat.query || activeChat.in_msg || "";

      // If the response is an object and contains a children key, extract the text from children
      if (Array.isArray(responseText)) {
        // Extract text from the children array if it's an object like in the example
        responseText = responseText.map(item => typeof item === 'object' && item.props ? item.props.children : item).join('');
      }


      // Convert to JSON string if it's still an object
      if (typeof responseText === 'object') {
        responseText = JSON.stringify(responseText);
      }

      navigator.clipboard
        .writeText(responseText)
        .then(() => {
          setIsFilled(true);
          setTimeout(() => {
            setIsFilled(false);
          }, 2000);
        })
        .catch((err) => {
          console.error("Failed to copy:", err);
          setIsFilled(false);
        });
    } else {
      setIsFilled(false); // No responses available
    }
  };
  const renderMessage = (message) => {
    if (typeof message === "string") {
      return message.split("\n").map((line, lineIndex) => (
        <span key={`line-${lineIndex}`}>
          {line.split(/(\*\*.*?\*\*|\bhttps?:\/\/[^\s]+\b)/g).map((part, partIndex) => {
            if (part.startsWith("**") && part.endsWith("**")) {
              // Bold text
              return (
                <strong key={`bold-${partIndex}`}>
                  {part.slice(2, -2)} {/* Remove ** markers */}
                </strong>
              );
            } else if (/^https?:\/\/[^\s]+$/.test(part)) {
              // Link
              return (
                <a key={`link-${partIndex}`} href={part} target="_blank" rel="noopener noreferrer">
                  {part}
                </a>
              );
            }
            return <span key={`part-${partIndex}`}>{part}</span>;
          })}
          {lineIndex !== message.split("\n").length - 1 && <br />}
        </span>
      ));
    }
    return message; // If it's not a string, return it as is (could be an object or null)
  };



  // useEffect(() => {
  //   if (queryResponse) {
  //     console.log("Query Response:", queryResponse);
  //   }
  //   // console.log(queryResponse?.data, "queryResponse.data");
  //   if (queryResponse && queryResponse.status === "success") {
  //     const responseMessage = queryResponse.data.message;

  //     console.log("Submitted Prompt:", submittedPrompt);
  //     console.log("Response Message:", responseMessage);
  //     let payload = {
  //       query: responseMessage,
  //       isMine: false,
  //     };

  //     setAllResponses((prevResponses) => [...prevResponses, payload]);
  //   }
  // }, [queryResponse]);

  const [sidebarOpen, setSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  const likeanimation = keyframes`
      0% { transform: rotate(0) scale(1); }
      25% { transform: rotate(30deg) scale(1);
      }
       75% { transform: rotate(-30deg) scale(1);
      }
      100% { transform: rotate(0) scale(1); }
    `;

  const likeanimationrest = keyframes`
    0% { transform: translateY(0); }
  `;

  const dotPulseBefore = keyframes`
  0% {
                box-shadow: 9984px 0 0 -5px;
            }

            30% {
                box-shadow: 9984px 0 0 2px;
            }

            60%,
            100% {
                box-shadow: 9984px 0 0 -5px;
            }
 
`;
  const dotPulse = keyframes`
   0% {
                box-shadow: 9999px 0 0 -5px;
            }

            30% {
                box-shadow: 9999px 0 0 2px;
            }

            60%,
            100% {
                box-shadow: 9999px 0 0 -5px;
            }

`;
  const dotPulseAfter = keyframes`
  0% {
                box-shadow: 10014px 0 0 -5px;
            }

            30% {
                box-shadow: 10014px 0 0 2px;
            }

            60%,
            100% {
                box-shadow: 10014px 0 0 -5px;
            }

`;

  return (
    <Box
      sx={{
        // overflow: "auto",
        background: theme.palette.primary.primary4,
        height: "100%",
        position: "relative",
      }}
    >
      <Stack
        sx={{
          p: { xs: "12px", sm: " 10px 20px", xl: "20px 32px" },
          borderBottom: "1px solid",
          borderBottomColor: theme.palette.border.border1,
          boxShadow: " 0px 4px 40px 0px #0A1432",
          position: "sticky",
          top: 0,
          background: theme.palette.primary.primary3,
        }}
      >
        <Typography
          variant="p"
          sx={{
            color: theme.palette.secondary.main,
            fontWeight: "700",
            fontSize: "18px",
            mr: "10px",
          }}
          fullWidth
        >
          Models
        </Typography>

        <Grid
          container
          spacing={{ xs: "10px", lg: "16px" }}
          justifyContent={"start"}
          alignItems={"stretch"}
          columns={{ xs: 8, lg: 6, xl: 5 }}
          mt={"10px"}
        >
          {displayModels && displayModels.length > 0 ? (
            displayModels?.map((model, index) => (
              <Grid size={{ xs: 2, lg: 1 }} key={index}>
                <Box
                  sx={{
                    width: "100%",
                    height: "100%",
                    background: theme.palette.primary.primary5,
                    border: "2px solid",
                    borderColor:
                      chattingId === model.id
                        ? theme.palette.primary.main
                        : "transparent",
                    borderRadius: "12px",
                    p: { xs: "10px", sm: "12px", xl: "18px" },
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    "& > .child": {
                      maxWidth: { xs: "100%", lg: "50%", xl: "100%" },
                      height: "auto",
                    },
                  }}
                  onClick={() => handleModelClick(model.id)}
                >
                  <img
                    src={`${base_url}/${model.image}`}
                    alt={model.id}
                    className="child"
                  />
                </Box>
              </Grid>
            ))
          ) : (
            <>
              {textGeneration?.some((item) => item.isSelected)
                ? textGeneration.map((item, index) =>
                  item.isSelected ? (
                    <Grid size={{ xs: 2, lg: 1 }} key={index.id}>
                      <Box
                        sx={{
                          width: "100%",
                          height: "100%",
                          background: theme.palette.primary.morelight,
                          border: "2px solid",
                          borderColor:
                            chattingId === item.id
                              ? theme.palette.primary.main
                              : "transparent",

                          borderRadius: "12px",
                          p: { xs: "10px", sm: "12px", xl: "18px" },
                          textAlign: "center",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          "& > .child": {
                            maxWidth: { xs: "100%", lg: "50%", xl: "100%" },
                            height: "auto",
                          },
                        }}
                        onClick={() => handleModelClick(item.id)}
                      >
                        <img
                          src={`${base_url}/${item.image}`}
                          alt="text-model-logo"
                          className="child"
                        />
                      </Box>
                    </Grid>
                  ) : null
                )
                : imageGeneration?.map((item, index) =>
                  item.isSelected ? (
                    <Grid size={{ xs: 2, lg: 1 }} key={index}>
                      {" "}
                      <Box
                        sx={{
                          width: "100%",
                          height: "100%",
                          background:
                            chattingId === item.id
                              ? theme.palette.primary.main
                              : theme.palette.greyshades.grey100,
                          borderRadius: "12px",
                          p: { xs: "10px", sm: "18px" },
                          textAlign: "center",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          "& > .child": {
                            maxWidth: "100%",
                            height: "auto",
                          },
                        }}
                        onClick={() => handleModelClick(item.id)}
                      >
                        <img
                          src={`${base_url}/${item.image}`}
                          alt="image-model-logo"
                          className="child"
                        />
                      </Box>
                    </Grid>
                  ) : null
                )}
            </>
          )}
          {textGeneration && textGeneration.some((item) => item.isSelected) && (
            <>
              <Dialog
                open={openB}
                onClose={handleCloseB}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title" sx={{ p: 0 }}>
                  <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                    sx={{
                      borderBottom: "1px solid",
                      borderBottomColor: '#0A43AE',
                      pb: "12px",
                    }}
                  >
                    <Typography
                      variant="p"
                      sx={{
                        color: theme.palette.secondary.main,
                        fontWeight: "700",
                        fontSize: "18px",
                      }}
                    >
                      Models
                    </Typography>
                    <DialogActions>
                      <Button
                        onClick={handleCloseB}
                        sx={{ p: 0, minWidth: "auto", height: "auto" }}
                      >
                        <Modalclose onClick={handleCloseB}
                        />
                      </Button>
                    </DialogActions>
                  </Stack>
                </DialogTitle>

                <DialogContent sx={{ p: 0 }}>
                  <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                    sx={{ p: { xs: "12px 0 8px 0", sm: "26px 0 12px 0" } }}
                  >
                    <Typography
                      variant="p"
                      sx={{
                        color: theme.palette.secondary.main,
                        fontWeight: "700",
                        fontSize: { xs: "14px", sm: "16px" },
                      }}
                    >
                      Other Available Models
                    </Typography>
                    {/* 
                    <Typography
                      variant="p"
                      sx={{
                        color: theme.palette.secondary.main,
                        fontWeight: "500",
                        fontSize: { xs: "12px", sm: "14px" },
                      }}
                    >
                      Text Generation
                    </Typography> */}
                  </Stack>

                  <Grid
                    container
                    spacing={{ xs: "6px", sm: "12px" }}
                    justifyContent="start"
                    alignItems="stretch"
                    columns={{ xs: 3, sm: 4 }}
                  >
                    {textGeneration?.map((item) => (
                      <Grid size={{ xs: 1, xl: 1 }} key={item.id}>
                        <Box
                          sx={{
                            width: "100%",
                            height: "100%",
                            background: item.isSelected
                              ? theme.palette.primary.main
                              : theme.palette.primary.primary5,
                            borderRadius: "12px",
                            border:
                              item.isSelected
                                ? '1px solid transparent'
                                : '1px solid #0A43AE',
                            p: { xs: "6px", sm: "16px 20px" },
                            textAlign: "center",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            position: "relative",
                            cursor: "pointer",

                            "& > .child": {
                              maxWidth: "100%",
                              height: "auto",
                            },
                          }}
                          onClick={() => handleActive(item.id)}
                        >
                          <img
                            src={`${base_url}/${item.image}`}
                            alt="logo"
                            className="child"
                          />
                          <Box
                            sx={{
                              position: "absolute",
                              top: { xs: "-4px", sm: "1px", xl: "4px" },
                              right: { xs: "2px", sm: "5px", xl: "9px" },
                              "& > .tickimg": {
                                maxWidth: { xs: "50%", sm: "75%", xl: "80%" },
                              },
                            }}
                            className="child"
                          >
                            {item.isSelected ? (
                              <img
                                src={Tick}
                                alt="tick-icon"
                                className="tickimg"
                              />
                            ) : (
                              ""
                            )}
                          </Box>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>

                  <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                    sx={{ p: "16px 0 12px 0" }}
                  ></Stack>

                  <Stack
                    direction={"row"}
                    justifyContent={"end"}
                    alignItems={"center"}
                    sx={{ p: "22px 0 0px 0" }}
                  >
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      sx={{
                        p: { xs: "5px 16px ", sm: "10px 22px" },
                        backgroundColor: "primary.Main",
                        fontSize: "16px",
                        fontWeight: "500",
                        borderRadius: "50px",
                        height: "auto",
                      }}
                      onClick={() => {
                        handleSave();
                        handleCloseB();
                      }}
                    >
                      Save Preferences
                    </Button>
                  </Stack>
                </DialogContent>
              </Dialog>

              <Grid size={{ xs: 2, lg: 1, xl: 1 }}>
                <Button
                  sx={{
                    width: "100%",
                    height: "100%",
                    background: theme.palette.primary.primary5,
                    borderRadius: "12px",
                    p: { xs: "10px", sm: "18px" },
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    "& > .child": {
                      maxWidth: "100%",
                      height: "auto",
                    },
                  }}
                  onClick={handleClickOpenB}
                >
                  <img src={Addllmchat} alt="logo" className="child" />
                </Button>
              </Grid>
            </>
          )}
        </Grid>
      </Stack>

      <Stack
        sx={{
          p: { xs: "12px", sm: "20px", xl: "46px 32px" },
          overflowY: "auto",
          // maxHeight:  { xs: "70vh", sm: "50vh", xl: "60vh" },
          maxHeight: {
            xs: "calc( 100vh - 379px)",
            sm: "calc( 100vh - 404px)",
            lg: "calc( 100vh - 355px)",
            xl: "calc( 100vh - 435px)",
          },
        }}
        spacing={"20px"}
        ref={chatContainerRef}
      >
      {allResponses?.length > 0 &&
  allResponses.map((entry, index) => (
    <Stack key={index} spacing={2}>
      {/* User prompt */}
      {entry.isMine ? (
        <Stack alignItems={"end"}>
          <Box
            sx={{
              background: theme.palette.primary.primary6,
              color: theme.palette.secondary.main,
              p: "12px 16px",
              borderRadius: "8px",
              fontSize: "16px",
              fontWeight: "500",
            }}
          >
            {entry.query || entry.message || entry.in_msg}
          </Box>
        </Stack>
      ) : (
        <Stack alignItems={"start"} direction={"row"} className="output-chat">
          <Box
            sx={{
              color: theme.palette.secondary.main,
              p: { xs: "8px", sm: "12px 16px" },
              borderRadius: "8px",
              fontSize: "16px",
              fontWeight: "500",
            }}
          >
            {/* Render text message if present */}
            {entry.message && renderMessage(entry.message)}

            {/* Render image if image_url is present */}
            {entry.image_url && (
              <Box
                component="img"
                src={`${base_urls}${entry.image_url}`}
                alt={`Image for Message ${index + 1}`}
                sx={{
                  width: "100%",
                  maxWidth: "500px",
                  height: "auto",
                  mt: 2,
                  borderRadius: "8px",
                  mb: 4, // Add spacing between images if needed
                }}
              />
            )}
          

                    <Stack
                      direction={"row"}
                      alignItems={"center"}
                      justifyContent={"start"}
                      spacing={"20px"}
                      mt={"10px"}
                    >
                      {/* <Box onClick={() => handleChatlike(true)} sx={{
                        cursor: 'pointer',

                        animation:
                          feedbackStatus === "liked"
                            ? `${likeanimation} 1s ease-in-out `
                            : `${likeanimationrest} 1s ease-in-out `,
                      }}>
                        <Chatlike fill={filllikeColor}
                        />
                      </Box>
                      <Box onClick={() => handleChatlike(false)}
                        sx={{
                          cursor: 'pointer',
                          animation:
                            feedbackStatus === "unliked"
                              ? `${likeanimation} 1s ease-in-out `
                              : `${likeanimationrest} 1s ease-in-out `,
                        }}>
                        <Chatdislike fill={fillunlikeColor}
                        />
                      </Box>
                      <Box
                        sx={{
                          cursor: 'pointer',

                        }}>
                        <Chatrefresh />
                      </Box>
                      <Box
                        sx={{
                          cursor: 'pointer',

                        }}>
                        <Chatcopy />
                      </Box> */}
                    </Stack>
                  </Box>
                </Stack>
              )}
            </Stack>
          ))}
      </Stack>

      {/* <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
        sx={{
          position: "absolute",
          left: '0px',
          bottom: '15px',
          width: '100%',
          p: { xs: "12px", sm: " 0px 20px", xl: "0px 32px" },
        }}
      >
        <Box sx={{
          position: 'relative',
          left: '-9999px',
          width: '10px',
          height: '10px',
          borderRadius: '5px',
          color: '#0A43AE',
          boxShadow: '9999px 0 0 -5px',
          animation: `${dotPulse} 1.5s infinite linear`,
          animationDelay: '0.25s',

          '&::before': {
            content: '""',
            display: 'inline-block',
            position: 'absolute',
            top: 0,
            width: '10px',
            height: '10px',
            borderRadius: '5px',
            animation: `${dotPulseBefore} 1.5s infinite linear`,
            animationDelay: '0s',
          },

          '&::after': {
            content: '""',
            display: 'inline-block',
            position: 'absolute',
            top: 0,
            width: '10px',
            height: '10px',
            borderRadius: '5px',
            animation: `${dotPulseAfter} 1.5s infinite linear`,
            animationDelay: '0.5s',
          },
        }}></Box>

        <Stack
          direction={"row"}
          alignItems={"center"}
          justifyContent={"start"}
          spacing={"20px"}
          mt={"10px"}
        >
          <Box onClick={() => handleChatlike(true)} sx={{
            cursor: 'pointer',

            animation:
              feedbackStatus === "liked"
                ? `${likeanimation} 1s ease-in-out `
                : `${likeanimationrest} 1s ease-in-out `,
          }}>
            <Chatlike fill={filllikeColor}
            />
          </Box>
          <Box onClick={() => handleChatlike(false)}
            sx={{
              cursor: 'pointer',
              animation:
                feedbackStatus === "unliked"
                  ? `${likeanimation} 1s ease-in-out `
                  : `${likeanimationrest} 1s ease-in-out `,
            }}>
            <Chatdislike fill={fillunlikeColor}
            />
          </Box>

          <Box
            sx={{
              cursor: 'pointer',

            }}>
            <Chatrefresh />
          </Box>
          <Box
            sx={{
              cursor: 'pointer',

            }}>
            <Chatcopy />
          </Box>
        </Stack>

      </Stack > */}

      <Stack
        justifyContent={"center"}
        alignItems={"center"}
        p={{ xs: "16px 0", xl: "24px 0" }}
        sx={{
          position: "fixed",
          bottom: 0,
          left: { xs: "0", sm: "250px", xl: "330px" },
          right: 0,
          background: theme.palette.primary.primary4,
        }}
      >
        <Box sx={{ width: { xs: "96%", sm: "85%" } }}>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
            sx={{
              p: {
                xs: " 0 0 12px 0",
                sm: " 0px 20px 10px 20px",
                xl: "0px 32px 10px 32px",
              },
            }}
          >
            {loading && (
              <Box>
                <Box
                  sx={{
                    position: "relative",
                    left: "-9999px",
                    width: "10px",
                    height: "10px",
                    borderRadius: "5px",
                    color: "#0A43AE",
                    boxShadow: "9999px 0 0 -5px",
                    animation: `${dotPulse} 1.5s infinite linear`,
                    animationDelay: "0.25s",

                    "&::before": {
                      content: '""',
                      display: "inline-block",
                      position: "absolute",
                      top: 0,
                      width: "10px",
                      height: "10px",
                      borderRadius: "5px",
                      animation: `${dotPulseBefore} 1.5s infinite linear`,
                      animationDelay: "0s",
                    },

                    "&::after": {
                      content: '""',
                      display: "inline-block",
                      position: "absolute",
                      top: 0,
                      width: "10px",
                      height: "10px",
                      borderRadius: "5px",
                      animation: `${dotPulseAfter} 1.5s infinite linear`,
                      animationDelay: "0.5s",
                    },
                  }}
                ></Box>
              </Box>
            )}

            {!loading && (
              <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={"start"}
                spacing={"20px"}
              >
                {/* <Box
                onClick={() => handleChatlike(true)}
                sx={{
                  cursor: "pointer",

                  animation:
                    feedbackStatus === "liked"
                      ? `${likeanimation} 1s ease-in-out `
                      : `${likeanimationrest} 1s ease-in-out `,
                }}
              >
                <Chatlike fill={filllikeColor} />
              </Box> */}

                <Tooltip
                  title="Liked"
                  TransitionComponent={Zoom}
                  placement="top"
                >
                  <Box
                    onClick={() => handleChatlike(true)}
                    sx={{
                      cursor: "pointer",

                      animation:
                        feedbackStatus === "liked"
                          ? `${likeanimation} 1s ease-in-out `
                          : `${likeanimationrest} 1s ease-in-out `,

                      "& > .filled": {
                        display: feedbackStatus === "liked" ? "block" : "none",
                      },
                      "& > .outline ": {
                        display: feedbackStatus === "liked" ? "none" : "block",
                      },
                    }}
                  >
                    <Box className="outline">
                      <Chatlike />
                    </Box>
                    <Box className="filled">
                      {" "}
                      <Filledlikebtn />
                    </Box>
                  </Box>
                </Tooltip>

                <Tooltip
                  title="Dislike"
                  TransitionComponent={Zoom}
                  placement="top"
                >
                  <Box
                    onClick={() => handleChatlike(false)}
                    sx={{
                      cursor: "pointer",
                      animation:
                        feedbackStatus === "unliked"
                          ? `${likeanimation} 1s ease-in-out `
                          : `${likeanimationrest} 1s ease-in-out `,

                      animation:
                        feedbackStatus === "unliked"
                          ? `${likeanimation} 1s ease-in-out `
                          : `${likeanimationrest} 1s ease-in-out `,

                      "& > .dislikefilled": {
                        display:
                          feedbackStatus === "unliked" ? "block" : "none",
                      },
                      "& > .dislikeoutline ": {
                        display:
                          feedbackStatus === "unliked" ? "none" : "block",
                      },
                    }}
                  >
                    <Box className="dislikeoutline">
                      <Chatdislike />
                    </Box>
                    <Box className="dislikefilled">
                      {" "}
                      <Filleddislikebtn />
                    </Box>
                  </Box>
                </Tooltip>

                {/* <Box
                onClick={() => handleChatlike(false)}
                sx={{
                  cursor: "pointer",
                  animation:
                    feedbackStatus === "unliked"
                      ? `${likeanimation} 1s ease-in-out `
                      : `${likeanimationrest} 1s ease-in-out `,
                }}
              >
                <Chatdislike fill={fillunlikeColor} />
              </Box> */}

                <Box
                  sx={{
                    cursor: "pointer",
                  }}
                  onClick={() => handleRegenerate()}
                >
                  <Chatrefresh />
                </Box>

                <Tooltip title="Copy">
                  <Box
                    onClick={copyLastResponse}
                    sx={{
                      cursor: "pointer",
                    }}
                  >
                    <Box
                      className="outline"
                      sx={{ display: isFilled ? "none" : "block" }}
                    >
                      <Chatcopy />
                    </Box>
                    <Box
                      className="filled"
                      sx={{ display: isFilled ? "block" : "none" }}
                    >
                      <Filleddiscopybtn />
                    </Box>
                  </Box>
                </Tooltip>

                <Snackbar
                  open={snackbarOpen}
                  autoHideDuration={2000}
                  onClose={handleSnackbarClose}
                  anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                >
                  <Alert
                    onClose={handleSnackbarClose}
                    severity={feedbackStatus === "liked" ? "success" : "info"}
                    sx={{ width: "100%" }}
                  >
                    {feedbackStatus === "liked" ? "Liked" : "Unliked"}
                  </Alert>
                </Snackbar>
              </Stack>
            )}
          </Stack>
          <Dialog
            open={showLowBalanceModal}
            onClose={closeLowBalanceModal}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{
              "& .css-umy2on-MuiPaper-root-MuiDialog-paper": {
                width: "375px",
              },
            }}
          >
            <DialogTitle id="alert-dialog-title" sx={{ p: 0 }}>
              <Stack
                direction={"row"}
                justifyContent={"space-between"}
                alignItems={"center"}
                sx={{
                  borderBottom: "1px solid",
                  borderBottomColor: theme.palette.greyshades.grey100,
                  pb: "12px",
                }}
              >
                <Typography
                  variant="p"
                  sx={{
                    color: theme.palette.secondary.main,
                    fontWeight: "700",
                    fontSize: "18px",
                  }}
                >
                  Top Up to Continue Service
                </Typography>
                <DialogActions>
                  <Button
                    onClick={closeLowBalanceModal}
                    sx={{ p: 0, minWidth: "auto", height: "auto" }}
                  >
                    <Modalclose onClick={closeLowBalanceModal}
                    />
                  </Button>
                </DialogActions>
              </Stack>
            </DialogTitle>

            <DialogContent sx={{ p: 0 }}>
              <Stack
                direction={"row"}
                justifyContent={"space-between"}
                alignItems={"center"}
                sx={{ p: "12px 0 0px 0" }}
              >
                <Typography
                  variant="p"
                  sx={{
                    color: theme.palette.secondary.main,
                    fontWeight: "400",
                    fontSize: "18px",
                  }}
                >
                  Your balance is zero. Please top up to continue using the
                  service.
                </Typography>
              </Stack>

              <Grid
                container
                spacing={"12px"}
                justifyContent={"start"}
                alignItems={"stretch"}
                columns={2}
                sx={{ p: "32px 0 0px 0" }}
              >
                <Grid size={{ xs: 1, xl: 1 }}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    sx={{
                      p: "10px 22px",
                      backgroundColor: "primary.Main",
                      fontSize: "16px",
                      fontWeight: "500",
                      borderRadius: "50px",
                      height: "auto",
                    }}
                    onClick={openLow}
                  >
                    Top up wallet
                  </Button>
                </Grid>
                <Grid size={{ xs: 1, xl: 1 }}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    sx={{
                      p: "10px 22px",
                      backgroundColor: "transparent",
                      fontSize: "16px",
                      fontWeight: "500",
                      borderRadius: "50px",
                      border: "1px solid #fff",
                      height: "auto",
                    }}
                    onClick={closeLowBalanceModal}
                  >
                    Remind me later
                  </Button>
                </Grid>
              </Grid>
            </DialogContent>
          </Dialog>

          <Stack direction={"row"} alignItems={"center"}>
            <Button
              type="button"
              sx={{
                position: "relative",
                minWidth: { xs: "40px", xl: "44px" },
                width: { xs: "40px", xl: "44px" },
                height: { xs: "40px", xl: "44px" },
                borderRadius: "50%",
                background: theme.palette.primary.main,
                p: { xs: "2px", sm: "8px" },
                mr: "10px",
                display: { xs: "block", sm: "none" },
                "& > .child": {
                  maxWidth: "100%",
                  height: "auto",
                },
              }}
              onClick={handleClickOpenD}
            >
              <img src={Modelicon} alt="send" className="child" />
              <Box
                sx={{
                  position: "absolute",
                  top: "-2px",
                  right: "-2px",
                  width: "14px",
                  height: "14px",
                  fontSize: "12px",
                  fontWeight: "700",
                  background: "#FF0000",
                  borderRadius: "50%",
                  color: theme.palette.white.white,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                4
              </Box>
            </Button>

            <Dialog
              open={openD}
              onClose={handleCloseD}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              sx={{
                "& .css-umy2on-MuiPaper-root-MuiDialog-paper": {
                  width: "375px",
                },
              }}
            >
              <DialogTitle id="alert-dialog-title" sx={{ p: 0 }}>
                <Stack
                  direction={"row"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  sx={{
                    borderBottom: "1px solid",
                    borderBottomColor: theme.palette.greyshades.grey100,
                    pb: "12px",
                  }}
                >
                  <Typography
                    variant="p"
                    sx={{
                      color: theme.palette.secondary.main,
                      fontWeight: "700",
                      fontSize: "18px",
                    }}
                  >
                    Selected Models
                  </Typography>
                  <DialogActions>
                    <Button
                      onClick={handleClose}
                      sx={{ p: 0, minWidth: "auto", height: "auto" }}
                    >
                      <Modalclose onClick={handleClose} />
                    </Button>
                  </DialogActions>
                </Stack>
              </DialogTitle>

              <DialogContent sx={{ p: 0 }}>
                <Box sx={{ py: "20px" }}>
                  <Grid
                    container
                    spacing={"8px"}
                    sx={{ height: "100%" }}
                    columns={{ xs: 3, sm: 2, xl: 2 }}
                  >
                    <Grid size={1}>
                      <Box
                        sx={{
                          width: "100%",
                          height: "100%",
                          background: theme.palette.primary.main,
                          borderRadius: "12px",
                          p: "18px",
                          textAlign: "center",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          position: "relative",
                          "& > .child": {
                            maxWidth: "100%",
                            height: "auto",
                          },
                        }}
                      >
                        <img src={Gemma} alt="logo" className="child" />

                        <Box
                          sx={{
                            position: "absolute",
                            top: "6px",
                            right: "12px",
                          }}
                          className="child"
                        >
                          <img src={Tick} alt="tick-icon" />
                        </Box>
                      </Box>
                    </Grid>
                    <Grid size={1}>
                      <Box
                        sx={{
                          width: "100%",
                          height: "100%",
                          background: theme.palette.primary.main,
                          borderRadius: "12px",
                          p: "18px",
                          textAlign: "center",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          position: "relative",
                          "& > .child": {
                            maxWidth: "100%",
                            height: "auto",
                          },
                        }}
                      >
                        <img src={Mistral} alt="logo" className="child" />
                        <Box
                          sx={{
                            position: "absolute",
                            top: "6px",
                            right: "12px",
                          }}
                          className="child"
                        >
                          <img src={Tick} alt="tick-icon" />
                        </Box>
                      </Box>
                    </Grid>
                    <Grid size={1}>
                      <Box
                        sx={{
                          width: "100%",
                          height: "100%",
                          background: theme.palette.primary.main,
                          borderRadius: "12px",
                          p: "18px",
                          textAlign: "center",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          position: "relative",
                          "& > .child": {
                            maxWidth: "100%",
                            height: "auto",
                          },
                        }}
                      >
                        <img src={Chatgpt} alt="logo" className="child" />
                        <Box
                          sx={{
                            position: "absolute",
                            top: "6px",
                            right: "12px",
                          }}
                          className="child"
                        >
                          <img src={Tick} alt="tick-icon" />
                        </Box>
                      </Box>
                    </Grid>
                    <Grid size={1}>
                      <Box
                        sx={{
                          width: "100%",
                          height: "100%",
                          background: theme.palette.primary.main,
                          borderRadius: "12px",
                          p: "18px",
                          textAlign: "center",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          position: "relative",
                          "& > .child": {
                            maxWidth: "100%",
                            height: "auto",
                          },
                        }}
                      >
                        <img src={Geminilogo} alt="logo" className="child" />
                        <Box
                          sx={{
                            position: "absolute",
                            top: "6px",
                            right: "12px",
                          }}
                          className="child"
                        >
                          <img src={Tick} alt="tick-icon" />
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>

                  <Box sx={{ padding: "20px 0 10px 0" }}>
                    <Typography
                      variant="p"
                      sx={{
                        color: theme.palette.secondary.main,
                        fontWeight: "700",
                        fontSize: "18px",
                      }}
                    >
                      Add More LLM’s
                    </Typography>
                  </Box>

                  <Grid
                    container
                    spacing={"8px"}
                    sx={{ height: "100%" }}
                    columns={{ xs: 3, sm: 2, xl: 2 }}
                  >
                    <Grid size={1}>
                      <Box
                        sx={{
                          width: "100%",
                          height: "100%",
                          background: theme.palette.primary.main,
                          borderRadius: "12px",
                          p: "18px",
                          textAlign: "center",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          position: "relative",
                          "& > .child": {
                            maxWidth: "100%",
                            height: "auto",
                          },
                        }}
                      >
                        <img src={Websearch} alt="logo" className="child" />

                        <Box
                          sx={{
                            position: "absolute",
                            top: { xs: "-4px", sm: "6px" },
                            right: { xs: "2px", sm: "12px" },
                            "& > .tickimg": {
                              maxWidth: "50%",
                            },
                          }}
                          className="child"
                        >
                          <img src={Tick} alt="tick-icon" className="tickimg" />
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </DialogContent>
            </Dialog>

            <FormControl fullWidth sx={{ mb: { xs: 1, xl: 2 } }}>
              <OutlinedInput
                name="prompt"
                placeholder="Write your prompt..."
                value={prompt}
                onChange={handleChange}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && !loading) {
                    handleSubmit();
                  }
                }}
                sx={{
                  color: "#fff",
                  p: "13px 12px",
                  borderRadius: "50px",
                  border: "1px solid",
                  borderColor: theme.palette.primary.main,
                  height: { xs: "40px", xl: "60px" },
                }}
                endAdornment={
                  <InputAdornment
                    position="end"
                    sx={{ pr: "0px", cursor: "pointer" }}
                  >
                    <Button
                      type="button"
                      sx={{
                        p: 0,
                        minWidth: "auto",
                        width: { xs: "30px", xl: "44px" },
                        height: { xs: "30px", xl: "44px" },
                        borderRadius: "50%",
                        background: loading
                          ? theme.palette.greyshades.grey100
                          : theme.palette.primary.main,

                        p: "6px",
                        "& > .child": {
                          maxWidth: "100%",
                          height: "auto",
                        },
                      }}
                      onClick={handleSubmit}
                      disabled={loading || prompt.trim() === ""}                    >
                      <img src={send} alt="send" className="child" />
                    </Button>
                  </InputAdornment>
                }
              />
            </FormControl>
          </Stack>

          <Typography
            variant="h6"
            sx={{
              color: theme.palette.secondary.main,
              fontWeight: "500",
              fontSize: "14px",
              textAlign: "center",
            }}
          >
            Asklms can make mistakes.{" "}
            <Link
              href="#"
              sx={{
                color: theme.palette.secondary.main,
                fontWeight: "500",
                fontSize: "14px",
                textDecoration: "underline",
              }}
            >
              Terms & Conditions
            </Link>
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
}

export default Chat;
